// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.multi-select-selected-tags_wrapper__Gju8Y {
  display: 'flex';
  flex-wrap: 'wrap';
  max-width: '100%';
  max-height: '100%';
  overflow: 'auto';
  gap: '4px';
}
`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/select/multi-select-selected-tags.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ","sourcesContent":[".wrapper {\n  display: 'flex';\n  flex-wrap: 'wrap';\n  max-width: '100%';\n  max-height: '100%';\n  overflow: 'auto';\n  gap: '4px';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `multi-select-selected-tags_wrapper__Gju8Y`
};
export default ___CSS_LOADER_EXPORT___;
